import React from 'react';
import LoadingButton from '../../../../../../../../components/LoadingButton';
import { useT } from '../../../../../../../..//i18n/LanguageProvider';

interface Props {
	closeEditModalHandler: () => void;
	updateRecipientHandler?: (e: any) => void;
	recipientEdit: boolean;
	recipientOnEdit?: any;
	computeMergeTags: () => Array<any>;
	recipientValueChangeHandler: (inputLabel: string, value: string) => void;
	isRecipientEditLoading: boolean;
}

const UserForm: React.FC<Props> = ({
	updateRecipientHandler,
	recipientOnEdit,
	closeEditModalHandler,
	recipientEdit,
	computeMergeTags,
	recipientValueChangeHandler,
	isRecipientEditLoading,
}) => {
	const { t } = useT();
	return (
		<form className="space-y-4" onSubmit={updateRecipientHandler}>
			<div className="text-xs font-normal text-mediumGray"></div>
			<div className="text-xs font-semibold text-mediumGray">{t('schedule.basicInfo')}</div>
			<div>
				<label htmlFor="name" className="block text-sm font-medium text-blackTextlight">{t('schedule.nameLabel')}</label>
				<div className="mt-1">
					<input
						id="name"
						name="name"
						type="name"
						autoComplete="current-password"
						placeholder={t('schedule.nameOfRecipient')}
						onChange={(e) => recipientValueChangeHandler(e.target.name, e.target.value)}
						required
						value={(recipientOnEdit && recipientOnEdit['name']) || ''}
						className="appearance-none block w-full px-3 py-2 border border-bordergray rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
					/>
				</div>
			</div>
			<div>
				<label htmlFor="email" className="block text-sm font-medium text-blackTextlight">{t('schedule.emailLabel')}</label>
				<div className="mt-1">
					<input
						id="email"
						name="email"
						onChange={(e) => recipientValueChangeHandler(e.target.name, e.target.value)}
						type="email"
						autoComplete="email"
						placeholder="johndoe@gmail.com"
						pattern="^\S+@\S+\.\S+$"
						required
						title="johndoe@example.com"
						value={(recipientOnEdit && recipientOnEdit['email']) || ''}
						className="appearance-none block w-full px-3 py-2 border border-bordergray rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
					/>
				</div>
			</div>
			<div className={computeMergeTags().length ? "text-mediumGray font-semibold text-xs gap-x-1 flex justify-start items-center" : "hidden "}>
				<p className="mb-3">{t('schedule.mergeTagsLabel')}</p>
			</div>
			{computeMergeTags().map((item: any) => {
				return (
					<div key={item.tagName}>
						<label htmlFor="phoneNumber" className="block text-sm font-medium text-blackTextlight">
							{item.tagName}
						</label>
						<div className="mt-1">
							<input
								id={item.tagName}
								name={item.tagName}
								onChange={(e) => recipientValueChangeHandler(e.target.name, e.target.value)}
								required
								value={(recipientOnEdit && recipientOnEdit[item.tagName]) || ''}
								className="appearance-none block w-full px-3 py-2 border border-bordergray rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
							/>
						</div>
					</div>
				);
			})}
			<div className="flex items-center space-x-4">
				<div className="flex items-center">
					<input
						id="isRecurring"
						name="isRecurring"
						type="checkbox"
						checked={recipientOnEdit ? !!recipientOnEdit['isRecurring'] : false}
						onChange={(e) => recipientValueChangeHandler(e.target.name, e.target.checked.toString())}
						className="h-4 w-4 text-indigo focus:ring-indigo border-gray-300 rounded"
					/>
					<label htmlFor="isRecurring" className="ml-2 block text-sm font-medium text-blackTextlight">{t('schedule.recurring')}</label>
				</div>
				{recipientOnEdit?.isRecurring && (
					<div className="flex-1">
						<select
							id="recurrenceType"
							name="recurrenceType"
							value={recipientOnEdit ? recipientOnEdit['recurrenceType'] : 'yearly'}
							onChange={(e) => recipientValueChangeHandler(e.target.name, e.target.value)}
							className="block w-full px-3 py-2 border border-bordergray rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
						>
							<option value="yearly">{t('schedule.yearly')}</option>
							<option value="monthly">{t('schedule.monthly')}</option>
							<option value="weekly">{t('schedule.weekly')}</option>
							<option value="daily">{t('schedule.daily')}</option>
						</select>
					</div>
				)}
			</div>
			<div className="mt-4 flex justify-end gap-2 " >
				<button
					type="button"
					className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-white border border-transparent rounded-md "
					onClick={closeEditModalHandler}
				>{t('schedule.cancel')}</button>
				<LoadingButton
					isLoading={isRecipientEditLoading}
					disabled={isRecipientEditLoading}
					type="submit"
					className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo border border-transparent rounded-md "
				>
					{recipientEdit ? t('schedule.update') : t('schedule.add')}
				</LoadingButton>
			</div>
		</form>
	);
};

export default UserForm;
